export default {
  LIST_TO_CONNECT: (state, payload) => {
    state.listToConnect.push(payload);
  },

  SET_LIST_TO_CONNECT: (state, payload) => {
    state.listToConnect = [...payload];
  },
};
